import { Fragment, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, ToolTip } from "../../../AbstractElements";
import { OutlineSVGTooltipsTitle } from "../../../Constants/Constants";
import { OutlineSVGTooltipsData, OutlineSVGTooltipsSubTitle } from "../../../Data/UiKits/Tooltip";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const OutlineSVGTooltips = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleTooltip = (index: number) => setOpenIndex(openIndex === index ? null : index);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={OutlineSVGTooltipsTitle} span={OutlineSVGTooltipsSubTitle} />
        <CardBody className="svg-tooltip">
          <div className="common-flex">
            {OutlineSVGTooltipsData &&
              OutlineSVGTooltipsData.map((item, index) => (
                <Fragment key={index}>
                  <Btn outline={true} color={item.class} id={`OutlineSVG_${index}`} onClick={() => toggleTooltip(index)}>
                   {item.icon}
                  </Btn>
                  <ToolTip isOpen={openIndex === index} target={`OutlineSVG_${index}`} toggle={() => toggleTooltip(index)}>
                    {item.text}
                  </ToolTip>
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default OutlineSVGTooltips;
